<template>
    <div :id="this.id" class="vue-app">
        <div>
            <component
                :apiActions="apiActions"
                :configTexts="configTexts"
                :startingMode="startingMode"
                :dynamicType="dynamicType"
                :is="currentView"
            ></component>
        </div>
    </div>
</template>

<script>
export default {
    name: "app",
    components: {
        "simulation-einkauf": () =>
            import(
                /* webpackChunkName: "simeinkauf" */ "@/components/simulations/Einkauf.vue"
            ),
        "simulation-einkaufspotenzial": () =>
            import(
                /* webpackChunkName: "simeinkaufpot" */ "@/components/simulations/Einkaufspotenzial.vue"
            ),
        "simulation-wef": () =>
            import(
                /* webpackChunkName: "simwef" */ "@/components/simulations/Wef.vue"
            ),
        "simulation-wefPayback": () =>
            import(
                /* webpackChunkName: "simwefpayback" */ "@/components/simulations/WefPayback.vue"
            ),
        "simulation-iv": () =>
            import(
                /* webpackChunkName: "simiv" */ "@/components/simulations/Iv.vue"
            ),
        "simulation-todesfall": () =>
            import(
                /* webpackChunkName: "simtodesfall" */ "@/components/simulations/Todesfall.vue"
            ),
        "simulation-todesfall25": () =>
            import(
                /* webpackChunkName: "simtodesfall25" */ "@/components/simulations/todesfall/Todesfall25.vue"
            ),
        "simulation-beitrag": () =>
            import(
                /* webpackChunkName: "simbeitrag" */ "@/components/simulations/Beitrag.vue"
            ),
        "simulation-pension2024": () =>
            import(
                /* webpackChunkName: "simpension2024" */ "@/components/simulations/pension/pension-beta/Pension2024.vue"
            ),
        "simulation-hypothekenrechner": () =>
            import(
                /* webpackChunkName: "simhypo" */ "@/components/simulations/Hypothekenrechner.vue"
            ),
        "simulation-budgetrechner": () =>
            import(
                /* webpackChunkName: "simbudgetrechner" */ "@/components/simulations/budgetrechner/Budgetrechner.vue"
            ),
        "widgets-vaus": () =>
            import(
                /* webpackChunkName: "widgetvaus" */ "@/components/widgets/Vaus.vue"
            ),
        preload: () =>
            import(
                /* webpackChunkName: "preload" */ "@/components/standalone/Preload.vue"
            ),
        rentenrechner: () =>
            import(
                /* webpackChunkName: "standalonerentenrechner" */ "@/components/standalone/Rentenrechner.vue"
            ),
        beitragsrechner: () =>
            import(
                /* webpackChunkName: "standalonebeitragsrechner" */ "@/components/standalone/Beitragsrechner.vue"
            ),
    },
    props: ["id", "data"],
    data() {
        return {
            currentView: "widgets-dashboard",
            apiActions: {
                simulation: "",
                widgets: "",
                taxIncome: "",
                taxCapital: "",
                taxProvision: "",
                contribution: "",
                buyinUrl: "",
                divorcerepaymentUrl: "",
                wefrepaymentUrl: "",
                loggingUrl: "",
                welcomeUrl: "",
                preloadPostUrl: "",
            },
            configTexts: {},
            startingMode: "static",
            dynamicType: "",
        };
    },
    created() {
        //URL for api depending on environment
        let baseUrl = window.location.origin;
        //Get Actions from typo3 template
        this.apiActions.simulation = baseUrl + this.data.simulationendpoint;
        this.apiActions.taxIncome = baseUrl + this.data.incometaxurl;
        this.apiActions.taxCapital = baseUrl + this.data.capitaltaxurl;
        this.apiActions.taxProvision =
            baseUrl + this.data.provisionalanalysisurl;
        this.apiActions.contribution = baseUrl + this.data.contributionlevelurl;
        this.apiActions.buyinUrl = baseUrl + this.data.buyinurl;
        this.apiActions.divorcerepaymentUrl =
            baseUrl + this.data.divorcerepaymenturl;
        this.apiActions.wefrepaymentUrl = baseUrl + this.data.wefrepaymenturl;

        // These urls are not set by all plugin types
        if (this.data.loggingendpoint) {
            this.apiActions.loggingUrl = baseUrl + this.data.loggingendpoint;
        }
        if (this.data.welcomefinishedurl) {
            this.apiActions.welcomeUrl = baseUrl + this.data.welcomefinishedurl;
        }
        this.apiActions.preloadPostUrl = baseUrl + this.data.preloadposturl;

        //Get view to start from typo3
        this.currentView = this.data.mode;
        switch (this.data.mode) {
            case "widgets-vaus":
                this.dynamicType = "vaus";
                this.startingMode = "dynamic";
                break;
            case "rentenrechner":
                this.currentView = "rentenrechner";
                break;
            case "beitragsrechner":
                this.currentView = "beitragsrechner";
                break;
            case "preload":
                this.currentView = "preload";
                this.startingMode = "dynamic";
                break;
            default:
                break;
        }

        for (let d in this.data) {
            if (d.startsWith("url")) {
                let newd = d.substr(3);
                this.apiActions[`url${newd}`] = this.data[d];
            }
        }

        for (let d in this.data) {
            if (d.startsWith("texts")) {
                let newd = d.substr(5);
                this.configTexts[newd] = this.data[d];
            }
        }
    },
};
</script>
<style lang="scss">
@import "scss/custom";
</style>
